import React, { useCallback, useState, useEffect } from 'react'
import { Formik, Form } from 'formik'
import { toast } from 'react-toastify'
import { FiFile } from 'react-icons/fi'
import { format } from 'date-fns'

import Yup from '../../../../../services/yup'
import { api, authHeaders } from '../../../../../services/api'

import { downloadRelatorioJasper } from '../../../../../util/file'

import {
    Button, Select, Calendar
} from '../../../../../components/Form'
import Spinner from '../../../../../components/Spinner'

import { Container, ButtonContainer } from './styles'

import rangeDayGif from '../../../../../assets/images/gifs/periodo-dias.gif'

const initialValues = {
    tipo: { label: 'Todas', value: 'D' },
    pagamento: '',
    fornecedor: '',
    evento: '',
    contaCorrente: ''
}

const validation = Yup.object().shape({
    tipo: Yup.object({ label: Yup.string(), value: Yup.mixed() }).required('Selecione o tipo'),
    pagamento: Yup.string().nullable(),
    contaCorrente: Yup.object({ label: Yup.string(), value: Yup.mixed() }),
    fornecedor: Yup.string().nullable(),
    evento: Yup.string().nullable()
})

const nomeRelatorio = 'Relatório de Pagamentos'

export default function (props) {
    const [contas, setContas] = useState([])
    const [fornecedores, setFornecedores] = useState([])
    const [eventos, setEventos] = useState([])

    async function loadContas() {
        const response = await api.get('conta_sindicato', authHeaders())

        setContas(response)
    }

    async function loadFornecedores() {
        const response = await api.get('fornecedor', authHeaders())

        setFornecedores(response)
    }

    async function loadEventos() {
        const response = await api.get('evento_contabil', authHeaders())

        setEventos(response)
    }

    useEffect(() => {
        loadContas()
        loadFornecedores()
        loadEventos()
    }, [])

    const handleSubmit = useCallback(async (values, { resetForm }) => {
        const {
            tipo,
            pagamento,
            evento,
            fornecedor,
            contaCorrente
        } = values

        const inicio = pagamento ? pagamento[0] : null
        const fim = pagamento ? pagamento[1] : null

        const nomebanco = contaCorrente?.label.split('-')[0].trim() === 'BB' ? 'BANCO DO BRASIL' : contaCorrente?.label.split('-')[0].trim() === 'CEF' ? 'CAIXA ECONOMICA FEDERAL' : contaCorrente?.label.split('-')[0].trim()

        try {
            const response = await api.post('relatorio', {
                relatorio: 'RelatorioPagamentos',
                parametros: {
                    idConta: contaCorrente?.value || '',
                    tipo: tipo?.value || '',
                    idEvento: evento?.value || '',
                    idFornecedor: fornecedor ? fornecedor.map(f => f.value).join(',') : '',
                    data: inicio !== null && fim !== null && (inicio.getTime() === fim.getTime()) ? format(new Date(inicio), 'yyyy-MM-dd') : '',
                    dataInicio: inicio !== null ? format(new Date(inicio), 'yyyy-MM-dd') : '',
                    dataFim: fim !== null ? format(new Date(fim), 'yyyy-MM-dd') : (inicio !== null) ? format(new Date(inicio), 'yyyy-MM-dd') : '',
                    banco: `${nomebanco} - ${contaCorrente?.label.split('- ')[1].trim()}`
                }
            }, {
                ...authHeaders(),
                responseType: 'blob'
            })

            downloadRelatorioJasper(response, nomeRelatorio)

            resetForm()
        } catch (e) {
            console.log(e)
            toast.error('Erro ao gerar o relatório.')
        }
    }, [])

    return (
        <Container className="animated fadeIn faster form" {...props}>
            <Formik
                initialValues={initialValues}
                validationSchema={validation}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({
                    isSubmitting, setFieldValue, resetForm
                }) => (
                    <Form>
                        <h2>{nomeRelatorio}</h2>

                        <Calendar
                            name="pagamento"
                            label="Período para busca"
                            selectionMode="range"
                            containerStyle={{ gridArea: 'f1' }}
                            tooltip={`<p>Com o calendário aberto, selecione a primeira data,<br/>em seguida, a segunda.</p><br/><img src="${rangeDayGif}" style="width:300px; height:auto" />`}
                        />

                        <Select
                            name="tipo"
                            label="Tipo de evento"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={[
                                { label: 'Todas', value: 'D' },
                                { label: 'Despesas fixas', value: 'DF' },
                                { label: 'Despesas variáveis', value: 'DV' }
                            ]}
                            containerStyle={{ gridArea: 'f2' }}
                        />

                        <Select
                            name="contaCorrente"
                            label="Conta corrente"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={contas.map(({ id, dados_bancarios }) => ({
                                label: `${dados_bancarios.instituicao.sigla} - AG ${dados_bancarios.agencia} C/C ${dados_bancarios.conta}`,
                                value: id
                            }))}
                            containerStyle={{ gridArea: 'f3' }}
                        />

                        <Select
                            name="fornecedor"
                            label="Fornecedor"
                            onChange={(selected, meta) => setFieldValue(meta.name, selected)}
                            options={fornecedores.map(({ id, pessoa }) => ({
                                label: pessoa.nome,
                                value: id
                            }))}
                            isMulti
                            containerStyle={{ gridArea: 'f4' }}
                        />

                        <Select
                            name="evento"
                            label="Evento"
                            onChange={(selected, meta) => {
                                setFieldValue(meta.name, selected)
                            }}
                            options={eventos.filter(({ tipo_evento_contabil }) => tipo_evento_contabil.id === 3 || tipo_evento_contabil.id === 4).map(({ id, nome, conta_contabil }) => ({
                                label: `${nome}${conta_contabil?.codigo_reduzido ? ` - ${conta_contabil.codigo_reduzido}` : ''}`,
                                value: id
                            }))}
                            containerStyle={{ gridArea: 'f5' }}
                        />

                        <Spinner
                            visible={isSubmitting}
                            label="Gerando relatório..."
                        />

                        <ButtonContainer>
                            <Button
                                onClick={resetForm}
                                className="transparent"
                            >
                                Limpar
                            </Button>

                            <Button
                                type="submit"
                                loading={isSubmitting}
                                className="white"
                            >
                                Gerar relatório
                                <FiFile size={20} />
                            </Button>
                        </ButtonContainer>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}
